import {url} from "../api/endpointURL";


class TransitionGraphAPI {
    
    async saveGraph(data, idToken) {
        try {
            
            const response = await fetch(`${url}/transition/graphs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken,
                },
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error saving graph:', error);
            throw error;
        }
    }

    async getUserGraphs(data, idToken) {
        try {
            
            const response = await fetch(`${url}/transition/graphs/view`, {
                method: 'POST', // Changed from GET to POST to send body
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error fetching graphs:', error);
            throw error;
        }
    }

    async getAllAccessibleGraphs(data, idToken) {
        try {
            
            const response = await fetch(`${url}/transition/graphs/accessible`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error fetching accessible graphs:', error);
            throw error;
        }
    }

    async getGraphById(data, idToken) {
        try {
            const { graphId } = data;
            if (!graphId) {
                throw new Error('Graph ID is required');
            }

            const response = await fetch(`${url}/transition/graphs/${graphId}`, {
                method: 'POST', // Changed from GET to POST to send body
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken
                },
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error fetching graph:', error);
            throw error;
        }
    }

    async updateGraph(data, idToken) {
        try {
            const { graphId } = data;
            if (!graphId) {
                throw new Error('Graph ID is required');
            }

            if (!data) {
                throw new Error('Graph data is required');
            }
            
            const requestBody = {
                ...data,
                graphData: data
            };
            
            const response = await fetch(`${url}/transition/graphs/${graphId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken
                },
                body: JSON.stringify(requestBody)
            });
            
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error updating graph:', error);
            throw error;
        }
    }
    
    async deleteGraph(data, idToken) {
        try {
            const { graphId } = data;
            if (!graphId) {
                throw new Error('Graph ID is required');
            }
            
            const response = await fetch(`${url}/transition/graphs/${graphId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken
                },
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error deleting graph:', error);
            throw error;
        }
    }
    
    async toggleGlobalStatus(data, idToken) {
        try {
            const { graphId, isGlobal } = data;
            if (!graphId) {
                throw new Error('Graph ID is required');
            }
            
            const response = await fetch(`${url}/transition/graphs/${graphId}/global`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken
                },
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            console.error('Error toggling global status:', error);
            throw error;
        }
    }

}

export default new TransitionGraphAPI();